import { useLayoutEffect } from 'react';
import usePreviousValue from "beautiful-react-hooks/usePreviousValue";
import traverseObjectMeshes from "../utils/traverseObjectMeshes";

export const useWireframe = (object, asWireframe = false ) => {
	const prevAsWireframe = usePreviousValue(asWireframe);

	useLayoutEffect(() => {
		if (asWireframe ||
			//prevent from traversing meshes if asWireframe = false and we're on the first render
			(prevAsWireframe !== undefined && asWireframe !== prevAsWireframe)) {
			traverseObjectMeshes(object, (material) => {
				material.wireframe = asWireframe;
			});
		}
	}, [object, asWireframe]);
};
